import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from '@material-ui/core';

const DeleteQuickNoteDialog = ({ open, onClose, onConfirm, note }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="delete-dialog-title"
      aria-describedby="delete-dialog-description"
    >
      <DialogTitle id="delete-dialog-title">Delete Quick Note?</DialogTitle>
      <DialogContent>
        <DialogContentText id="delete-dialog-description">
          Are you sure you want to delete this Quick Note? This action cannot be undone.
        </DialogContentText>
        {note && (
          <div style={{ marginTop: '16px' }}>
            <strong>Note Details:</strong>
            <div>User: {note.user?.name}</div>
            <div>Inventory User: {note.commentable?.name}</div>
            <div>Date: {note.interaction_date}</div>
            <div style={{ marginTop: '8px', maxHeight: '100px', overflow: 'auto' }}>
              Comment: {note.comment}
            </div>
          </div>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button onClick={onConfirm} color="secondary" variant="contained" autoFocus>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

DeleteQuickNoteDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  note: PropTypes.object,
};

DeleteQuickNoteDialog.defaultProps = {
  note: null,
};

export default DeleteQuickNoteDialog;

